module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('Dashboard', {
    attrs: {
      "design": _vm.designs,
      "demo": _vm.demo
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "transparent"
  }, [_vm._l((_vm.demo['picture-naming']), function(name) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/picture-naming/' + name + '.gif'
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.demo['lexical-decision']), function(kinds, lang) {
    return _c('li', [_vm._l((kinds), function(items, kind) {
      return _vm._l((items), function(name) {
        return _c('img', {
          attrs: {
            "src": './static/lexical-decision/' + lang + '-' + kind + '/' + name + '.png'
          }
        })
      })
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.demo['iq-tester']), function(item) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/iq-tester/' + item.Q + '.jpg'
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.designs['picture-naming']), function(name) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/picture-naming/' + name + '.gif'
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.designs['lexical-decision']), function(kinds, lang) {
    return _c('li', [_vm._l((kinds), function(items, kind) {
      return _vm._l((items), function(name) {
        return _c('img', {
          attrs: {
            "src": './static/lexical-decision/' + lang + '-' + kind + '/' + name + '.png'
          }
        })
      })
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.designs['iq-tester']), function(item) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/iq-tester/' + item.Q + '.jpg'
      }
    })])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("sychio")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0101cbac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 165
// module chunks = 1